import PropTypes from 'prop-types'
import { useTable, useRowSelect } from 'react-table'
import CustomSelect from './Inputs/Select'
import { trans } from '../../utils/utilsTrans'
import Input from './Inputs/Input'
import Pagination from '../Table/Pagination'
import { useEffect, useRef } from "react";
// import CustomSelect from '../UI/inputs/CustomSelect'
// import { get_nested } from "../../utils/miscellaneous";


const TablePagination = (props) => {
  const {
    columns,
    isSecondary,
    data,
    className,
    page,
    limit,
    total,
    usePagination,
    order,
    CustomPagination,
    rowClass,
    onRowClick,
    emptyText,
  } = props

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useRowSelect
    )
  const tableContainer = useRef()

  useEffect(() => {
    tableContainer.current.scroll({ top: 0, behavior: 'instant' })
  }, [page])

  const maxPage = Math.ceil(total / limit - 1)
  const firstData = limit * page + 1
  let lastData = limit * page + limit
  if (lastData > total) lastData = total

  return (
    <div
      className={'flex flex-col ' + (isSecondary ? 'flex-grow min-h-[0]' : '')}
    >
      <div
        ref={tableContainer}
        style={props.minHeight ? { minHeight: props.minHeight + 'px' } : {}}
        className={
          isSecondary
            ? 'flex-grow min-h-[0] shadow-sm overflow-auto custom-scrollbar'
            : ''
        }
      >
        <table
          {...getTableProps()}
          className={
            className +
            ' w-full border-spacing-y-8 table-component border-separate' +
            (isSecondary ? ' border-spacing-0' : '')
          }
        >
          <thead className='w- hidden md:table-header-group'>
            {headerGroups.map((headerGroup, i) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                {headerGroup.headers.map((column, n) => (
                  <th
                    key={n}
                    {...column.getHeaderProps()}
                    className={
                      'text-left font-medium text-sm text-greyLight1 text-left px-8' +
                      (column.collapse ? ' w-2 whitespace-nowrap  ' : ' ') +
                      (isSecondary
                        ? ' sticky z-20 top-0 bg-white py-[14px] border md:first:rounded-tl-8  md:first:border-l md:last:rounded-tr-8 border-l-0 '
                        : ' uppercase lg:first:pl-0 lg:last:pr-0') +
                      column.extraClass
                    }
                    style={column.width ? { width: column.size } : {}}
                  >
                    <div
                      className={
                        column.orderKey
                          ? 'hover:text-primary cursor-pointer'
                          : ''
                      }
                      onClick={() => {
                        if (column.orderKey)
                          props.onChangeOrder(
                            column.orderKey,
                            order[column.orderKey] === 'asc' ? 'desc' : 'asc'
                          )
                      }}
                    >
                      {column.render('Header')}
                      {column.orderKey ? (
                        <i
                          className={
                            'text-xs ml-8 ' +
                            (get_nested([0], order) === column.orderKey &&
                            !get_nested([1], order)
                              ? 'icon icon-chevront-up'
                              : 'icon icon-chevront-down')
                          }
                        />
                      ) : null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length === 0 ? (
              <tr className='border border-greyLight7 bg-white mb-12 text-sm'>
                <td
                  className={
                    'font-medium text-greyLight5 border-b-0 border-greyLight3 rounded-b-8 font-medium py-16 px-8 leading-base text-left lg:first:pl-16 lg:last:pr-16'
                  }
                  colSpan={columns.length}
                >
                  <div className='max-w-[536px] block mx-auto space-x-8 text-center'>
                    <span>{emptyText || trans('no_result')}</span>
                  </div>
                </td>
              </tr>
            ) : null}
            {rows.map((row, i) => {
              prepareRow(row)
              return (
                <tr
                  {...row.getRowProps()}
                  key={i}
                  className={
                    'group ' +
                    (rowClass || '') +
                    (isSecondary
                      ? ' odd:bg-backgroundPrimary'
                      : ' bg-white mb-12 text-sm flex flex-col md:table-row')
                  }
                  onClick={() => onRowClick && onRowClick(row.original)}
                >
                  {row.cells.map((cell, n) => {
                    return (
                      <td
                        key={n}
                        className={
                          (isSecondary
                            ? 'border border-greyLight7 border-t-0 border-l-0 first:border-l py-4 px-16'
                            : 'border-y border-greyLight7 font-medium py-16 px-8 leading-base text-greyLight1 text-left md:last:border-r md:last:rounded-r-8 md:first:border-l md:first:rounded-l-8 lg:first:pl-16 lg:last:pr-16') +
                          (cell.column.collapse
                            ? ' whitespace-nowrap md:w-2 w-full '
                            : ' ') +
                          cell.column.extraClass +
                          (onRowClick
                            ? ' group-hover:border-primaryLight1 transition-colors'
                            : '')
                        }
                        style={
                          cell.column.width ? { width: cell.column.size } : {}
                        }
                        {...cell.getCellProps()}
                      >
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      {usePagination ? (
        <Pagination
          firstData={firstData}
          lastData={lastData}
          total={total}
          page={page}
          limit={limit}
          maxPage={maxPage}
          onChangePage={props.onChangePage}
          onChangeLimit={props.onChangeLimit}
        />
      ) : null}
      {CustomPagination ? (
        <CustomPagination
          firstData={firstData}
          lastData={lastData}
          total={total}
          page={page}
          maxPage={maxPage}
          onChangePage={props.onChangePage}
        />
      ) : null}
    </div>
  )
}
TablePagination.propTypes = {
  columns: PropTypes.array,
}
TablePagination.defaultProps = {
  usePagination: true,
  CustomPagination: false,
  noResultText: 'no_result',
}

export default TablePagination
